/**
 * Minimal METAR → ATIS-row extraction for the LBA form's B6 block.
 * This is deliberately NOT a full decoder (use metar-taf-parser for display);
 * it pulls exactly the columns the form has: time, wind, visibility, clouds,
 * temp/dewpoint, QNH, trend. Handles degraded AUTO reports (/////KT).
 */
/** Split a NOAA/ARSO-style bulletin into station → latest raw report (without "METAR " prefix). */
export function indexMetarBulletin(text) {
    const out = {};
    for (let line of text.split(/=\s*/)) {
        line = line.trim().replace(/\s+/g, ' ');
        const m = line.match(/^(?:METAR|SPECI)\s+([A-Z]{4})\s/);
        if (m)
            out[m[1]] = line.replace(/^(METAR|SPECI)\s+/, '');
    }
    return out;
}
export function parseMetarToAtis(line) {
    const t = line.replace(/^(METAR|SPECI)\s+/, '').trim();
    const p = t.split(/\s+/);
    const o = { station: p[0] ?? '', raw: t };
    for (let i = 1; i < p.length; i++) {
        const w = p[i];
        let m;
        // everything after the trend indicator (or RMK) describes the FUTURE / remarks, not the observation
        if (w === 'NOSIG' || w === 'BECMG' || w === 'TEMPO' || w.startsWith('RMK'))
            break;
        if ((m = w.match(/^(\d{2})(\d{2})(\d{2})Z$/)))
            o.zeit = m[2] + m[3];
        else if ((m = w.match(/^(VRB|\d{3})(\d{2,3})(?:G(\d{2,3}))?KT$/))) {
            o.wind = `${m[1]}/${+m[2]}${m[3] ? 'G' + +m[3] : ''}`;
        }
        else if (w === 'CAVOK')
            o.sicht = 'CAVOK';
        // metres visibility: gate on the time group having been seen, not on wind (which may be /////KT)
        else if (o.sicht === undefined && o.zeit !== undefined && (m = w.match(/^(\d{4})$/))) {
            o.sicht = m[1] === '9999' ? '>10 km' : `${Math.round(+m[1] / 100) / 10} km`;
        }
        else if ((m = w.match(/^(\d{1,3})KM$/)))
            o.sicht = `${m[1]} km`;
        else if (/^(FEW|SCT|BKN|OVC|VV)\d{3}(CB|TCU)?$/.test(w))
            o.wolken = (o.wolken ? o.wolken + ' ' : '') + w;
        else if (['NCD', 'NSC', 'SKC', 'CLR'].includes(w))
            o.wolken = o.wolken ?? w;
        else if ((m = w.match(/^(M?\d{2})\/(M?\d{2})$/)))
            o.temp = `${m[1].replace('M', '-')}/${m[2].replace('M', '-')}`;
        else if ((m = w.match(/^Q(\d{3,4})$/)))
            o.qnh = m[1];
    }
    // trend = the tokens from the first trend indicator up to (not including) RMK
    const trendStart = p.findIndex((w, i) => i > 0 && (w === 'NOSIG' || w === 'BECMG' || w === 'TEMPO'));
    if (trendStart > 0) {
        const r = [];
        for (const w of p.slice(trendStart)) {
            if (w.startsWith('RMK'))
                break;
            r.push(w);
        }
        if (r.length)
            o.tendenz = r.join(' ');
    }
    return o;
}
//# sourceMappingURL=metar.js.map